import { render } from "./SurveyCard.vue?vue&type=template&id=40fa2df8&scoped=true"
import script from "./SurveyCard.vue?vue&type=script&lang=js"
export * from "./SurveyCard.vue?vue&type=script&lang=js"

import "./SurveyCard.vue?vue&type=style&index=0&id=40fa2df8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40fa2df8"]])

export default __exports__